import React from "react";
import { HeaderStates } from "./HeaderStates";
import { StartupState } from "./StartupState";

export const Providers = ({ children }) => {
  return (
    <StartupState>
      <HeaderStates>{children}</HeaderStates>
    </StartupState>
  );
};
